<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.6"
    stroke-linejoin="round"
    stroke-linecap="round"
    aria-hidden="true"
    focusable="false"
  >
    <rect x="3.5" y="5" width="17" height="14" rx="2.25" />
    <path d="M3.5 15h17" />
  </svg>
</template>
